import {getHistoryInfo, removeHistoryInfo, updateHistoryInfo, getBoxInfo, updateBoxInfo} from '../../utils/auth'
import {findPointList, queryRoutings, searchGoods, bookingRequest} from '../../api/station'
import moment from 'moment'

function roleCode(role) {
  if (role === '发货人') { return 'SHP' }
  if (role === '货代') { return 'FOR' }
  if (role === '收货方') { return 'CEE' }
  if (role === '通知') { return 'NOT' }
  if (role === '第二通知方') { return 'NOT2' }
  if (role === '指定账号') { return '' }
  if (role === '第三方订舱代理') { return 'PAY' }
  if (role === '报关行') { return '' }
}
const state = {
  contractCodeList: [],
  routeList: [],
  initialStation: '',
  terminalStation: '',
  searchDate: moment().format('YYYY-MM-DD'),
  searchOn: '离港',
  findPoints: [],
  airLineList: [],
  contractNumber: '',
  selectedPath: '',
  goodsDetail: [],
  referenceNo: '',
  roleList: ['货代'],
  companyName: 'JHL LOGISTICS CO LTD - HANGZHOU',
  companyAddress: '11TH DENGTA DEVELOPMENT MANSION HANGZHOU, Zhejiang China',
  officeInfo: {officeName: '', officeRemark: ''},
  goodsList: [],
  goodsHistory: getBoxInfo(),
  payInfo: {
    payType: 'Prepaid',
    payLocation: '',
    payUser: 'JHL LOGISTICS CO LTD - HANGZHOU'
  },
  historyList: getHistoryInfo(),
  activeIndex: 1
}
const mutations = {
  SET_ACTIVE_INDEX: (state, activeIndex) => {
    console.log('activeIndex = ', activeIndex)
    state.activeIndex = activeIndex
  },
  SET_GOODS_HISTORY: (state, goodsHistory) => {
    console.log('goodsHistory = ', goodsHistory)
    state.goodsHistory = goodsHistory
  },
  SET_HISTORY_LIST: (state, historyList) => {
    console.log('historyList = ', historyList)
    state.historyList = historyList
  },
  SET_PAY_INFO: (state, payInfo) => {
    console.log('payInfo = ', payInfo)
    state.payInfo = payInfo
  },
  SET_GOODS_LIST: (state, goodsList) => {
    console.log('goodsList = ', goodsList)
    state.goodsList = goodsList
  },
  SET_OFFICE_INFO: (state, officeInfo) => {
    console.log('officeRofficeInfoemark = ', officeInfo)
    state.officeRemark = officeInfo
  },
  SET_GOODS_DETAIL: (state, goodsDetail) => {
    console.log('goodsDetail = ', goodsDetail)
    state.goodsDetail = goodsDetail
  },
  SET_COMPANY_ADDRESS: (state, companyAddress) => {
    console.log('companyAddress = ', companyAddress)
    state.companyAddress = companyAddress
  },
  SET_COMPANY_NAME: (state, companyName) => {
    console.log('companyName = ', companyName)
    state.companyName = companyName
  },
  SET_ROLE_LIST: (state, roleList) => {
    console.log('roleList = ', roleList)
    state.roleList = roleList
  },
  SET_REFERENCE_NO: (state, referenceNo) => {
    console.log('referenceNo = ', referenceNo)
    state.referenceNo = referenceNo
  },
  SET_SELECTED_PATH: (state, selectedPath) => {
    console.log('selectedPath = ', selectedPath)
    state.selectedPath = selectedPath
  },
  SET_CONTRACT_NUMBER: (state, contractNumber) => {
    console.log('contractNumber = ', contractNumber)
    state.contractNumber = contractNumber
  },
  SET_CODE_LIST: (state, list) => {
    console.log('list = ', list)
    state.contractCodeList = list
  },
  SET_ROUTE_LIST: (state, list) => {
    console.log('list = ', list)
    state.routeList = list
  },
  SET_INITIAL_STATION: (state, initialStation) => {
    console.log('initialStation = ', initialStation)
    state.initialStation = initialStation
    state.airLineList = []
  },
  SET_TERMINAL_STATION: (state, terminalStation) => {
    console.log('terminalStation = ', terminalStation)
    state.terminalStation = terminalStation
    state.airLineList = []
  },
  SET_SEARCH_ON: (state, searchOn) => {
    state.searchOn = searchOn
  },
  SET_SEARCH_DATE: (state, searchDate) => {
    state.searchDate = searchDate
  },
  SET_AIR_LINE_LIST: (state, airLineList) => {
    console.log('airLineList = ', airLineList)
    state.airLineList = airLineList
  },
  SET_FIND_POINTS: (state, findPoints) => {
    state.findPoints = findPoints
  }
}
const actions = {
  saveBoxData({ commit }, box) {
    updateBoxInfo(box)
    commit('SET_GOODS_HISTORY', getBoxInfo())
  },
  saveHistory({ commit }) {
    // ROTTERDAM; NL; NLRTM
    // NEW YORK, NY; US; USNYC
    // TA-CROSS-CMA
    // LE HAVRE
    // 28091000
    updateHistoryInfo({
      contractNumber: state.contractNumber,
      terminalStation: state.terminalStation,
      initialStation: state.initialStation,
      searchOn: state.searchOn
    })
    commit('SET_HISTORY_LIST', getHistoryInfo())
  },
  removeHistory({ commit }, contractNumber) {
    removeHistoryInfo(contractNumber)
    commit('SET_HISTORY_LIST', getHistoryInfo())
  },
  getRouteList({ commit }) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        // commit('SET_ROUTE_LIST', tempPathList)
        resolve()
      }, 2000)
    })
  },
  getAirLineList({ commit }) {
    console.log('state = ', state)
    var departureDate = state.searchOn === '离港' ? state.searchDate : ''
    var arrivalDate = state.searchOn !== '到达' ? state.searchDate : ''
    return new Promise((resolve, reject) => {
      queryRoutings({
        'maxTs': 0,
        'placeOfLoading': state.initialStation.point.code,
        'placeOfDischarge': state.terminalStation.point.code,
        'departureDate': departureDate,
        'arrivalDate': arrivalDate,
        'searchRange': 21,
        'useRoutingStatistics': true,
        'pageNo': 1,
        'pageSize': 50,
        'shippingCompany': '0001'
      }).then(response => {
        console.log('response = ', response)
        var routerError = false
        var temps = []
        response.data.forEach((data) => {
          var isError = false
          data.routingDetails.forEach(value => {
            if (value.legTransitTime === null) {
              isError = true
            }
          })
          if (isError) {
            routerError = true
          } else {
            temps.push(data)
          }
        })
        commit('SET_SELECTED_PATH', '')
        if (routerError && temps.length === 0) {
          commit('SET_AIR_LINE_LIST', [])
          reject(new Error('未查到匹配线路'))
        } else {
          commit('SET_AIR_LINE_LIST', temps)
          resolve()
        }
      }).catch(error => {
        console.log('error = ', error)
        commit('SET_AIR_LINE_LIST', [])
        reject(error)
      })
    })
  },
  findPointsData({ commit }, content) {
    return new Promise((resolve, reject) => {
      findPointList({
        content: content.toUpperCase(),
        pointType: 'Sea'
      }).then(response => {
        console.log('response = ', response)
        commit('SET_FIND_POINTS', response.data)
        resolve()
      }).catch(error => {
        commit('SET_FIND_POINTS', [])
        console.log('error = ', error)
        reject(error)
      })
    })
  },
  requestGoodsData({ commit }, content) {
    return new Promise((resolve, reject) => {
      searchGoods({
        codeContains: content.toUpperCase(),
        pageNo: 1,
        pageSize: 50
      }).then(response => {
        console.log('response = ', response)
        commit('SET_GOODS_LIST', response.data)
        resolve()
      }).catch(error => {
        commit('SET_GOODS_LIST', [])
        console.log('error = ', error)
        reject(error)
      })
    })
  },
  bookingShipment({ commit }, content) {
    let cargos = []
    state.goodsDetail.forEach(value => {
      cargos.push({
        equipmentIsoCode: value.size,
        equipmentQuantity: parseInt(value.boxNum),
        commodityCode: value.code,
        documentedCommodityDesc: value.description,
        weight: value.boxWeight,
        weightUOM: value.unit,
        volumeUOM: 'MTQ'
        // volume: '0'
      })
    })
    let parties = []
    state.roleList.forEach(value => {
      parties.push({
        code: '0001713768',
        bookingParty: true,
        role: roleCode(value)
      })
    })
    return new Promise((resolve, reject) => {
      bookingRequest({
        agreementReference: state.contractNumber,
        queryRouteId: state.selectedPath.id,
        freightPaymentMode: state.payInfo.payType,
        freightPaymentPointCode: state.payInfo.payLocation.point.code,
        bookingRemarks: state.officeInfo.officeRemark,
        parties: parties,
        cargos: cargos
      }).then(response => {
        console.log('response = ', response)
        commit('SET_GOODS_LIST', response.data.list)
        commit('SET_', response.data.list)
        resolve()
      }).catch(error => {
        commit('SET_GOODS_LIST', [])
        console.log('error = ', error)
        reject(error)
      })
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/book.js